module.exports = __webpack_public_path__ + "static/datanetwork-169c567a75fc853f38447b0690a84114.png";